import _ from 'lodash';
import globalStore from '$$globalStore';
import projectsModel from '$$projectModel';
import rights from '../../../components/rights';
import constants from '$$helpers/constants';

export default (taskId, ganttId) => {
  const task = globalStore.getters['tasksModel/getTaskByGanttId'](+ganttId, +taskId);

  if (!task) {
    return [];
  }

  const projectConfig = projectsModel.getProjectConfig(+ganttId);
  const hasCostRight = rights.project.hasCostRight(+ganttId);

  const taskResources = globalStore.getters['tasksModel/getResourcesForTask'](+ganttId, +taskId);
  const projectResources = globalStore.getters['resourcesModel/getResourcesByProjectIdForUI'](+ganttId);

  const preparedResources = projectResources.reduce((result, resource) => {
    const taskResourceData = taskResources.find(taskResource => taskResource.resource_id === resource.id);

    if (projectConfig.isJira && resource.userId) {
      return result;
    }

    if (!taskResourceData) {
      return result;
    }

    result.push({
      resource_id: resource.id,
      name: resource.name,
      picture: resource.picture,
      value: !_.isNil(taskResourceData.value) ? taskResourceData.value : 0,
      type: resource.type,
      userId: resource.userId,
      hideValuesInTemplates: (resource.type === constants.RESOURCE_COST_TYPE && !hasCostRight)
        || (resource.type === constants.RESOURCE_TIME_TYPE && task.type === constants.TASK_TYPES.milestone),
    });

    return result;
  }, []);

  return _.orderBy(preparedResources, ['userId', 'name'], ['asc', 'asc']);
};
